import(/* webpackMode: "eager" */ "/var/www/discord.ru40portal.com/app/page.tsx");
